import "../../css/modules/swiper.css";
import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

function init() {
    new Swiper(".mySwiperServices", {
        modules: [Navigation, Pagination],
        pagination: {
            el: ".swiper-pagination"
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev"
        },
        slidesPerView: "auto",
        slidesOffsetAfter: 30,
        slidesOffsetBefore: 20
    });
}

export default { init };
